import { Col, Row } from "react-bootstrap";
import { Field } from "react-final-form";
import { useTranslation } from "react-i18next";
import BMXTextField from "../../../../../../Components/Inputs/BMXTextField/BMXTextField";
import BMXSeparator from "../../../../../../Components/Separator/BMXSeparator";
import { GlobalAuthFetch } from "../../../../../../Utils/GlobalAuthFetch/GlobalAuthFetch";
import { useState } from "react";
import BMXAsynchronous from "../../../../../../Components/Inputs/BMXAsynchronous/BMXAsynchronous";
import ScrollTable from "../../../../Tables/ScrollTable/ScrollTable";
import { Icon, Checkbox } from "@mui/material";
import { IconButton } from "@material-ui/core";
import { show, hide } from "redux-modal";
import { useDispatch } from "react-redux";
import { memoize } from "lodash";

const ServicePartFormStepOne = (props) => {
  const { t } = useTranslation();
  const { values, form, setSelectedParts, selectedParts } = props;

  const [options, setOptions] = useState([]);
  const dispatch = useDispatch();

  const showModal = (name, props) => {
    dispatch(show(name, props));
  };

  const hideModal = (name, props) => {
    dispatch(hide(name));
  };

  const detetePart = (part) => {
    setSelectedParts((p) =>
      p.filter((el) => el.manufacturerIndex !== part.manufacturerIndex),
    );
  };

  const getData = async (searchTerm) => {
    const data = GlobalAuthFetch({
      path: `/part/findByIndex/${searchTerm.toUpperCase()}`,
    });

    const [partsListPayload] = await Promise.all([data]);
    const partsList = partsListPayload?.payload?.data?.map((p) => {
      return {
        uuid: p.uuid,
        value: `${p.index}`,
        ...p,
      };
    });

    if (partsList?.length > 0) {
      setOptions(partsList);
    } else {
      setOptions([]);
    }
  };

  const summaryNetto = (el) =>
    (Number(el?.price || 0) * Number(el?.quantity || 0))?.toFixed(2);

  const memoizedSummaryNetto = memoize(summaryNetto);

  return (
    <div style={{ justifyContent: "flex-start" }}>
      <BMXSeparator title={t("global:servicepart.partsearch")} />
      <Row>
        <Col xs={5}>
          <div className="d-flex align-items-center">
            <Icon
              style={{
                fontSize: "20px",
                paddingBottom: "32px",
                marginRight: "0.3rem",
              }}
              className="primary text"
            >
              search
            </Icon>
            <Field
              style={{ width: "100%" }}
              currentValues={values}
              className="part"
              component={BMXAsynchronous}
              label={`${t("global:servicepart.part")}`}
              name="part"
              options={options}
              getData={getData}
              getOptionLabel={(option) => {
                if (option.manufacturerIndex)
                  return `${option.manufacturerIndex} - ${option.name}`;
                return option;
              }}
              data-cy="part"
              disablePortal={true}
              onChange={(part) => {
                delete part.updatedBy;
                delete part.updatedAt;
                delete part.uuid;
                delete part.folders;
                delete part.notes;

                setSelectedParts((p) =>
                  Boolean(part) &&
                  p?.filter(
                    (e) => e?.manufacturerIndex === part?.manufacturerIndex,
                  ).length === 0
                    ? [
                        ...p,
                        {
                          ...part,
                          price: Boolean(part?.price) ? part?.price : 0,
                          quantity: Boolean(part?.quantity)
                            ? part?.quantity
                            : 1,
                          used: Boolean(part?.used?.value)
                            ? part?.used?.value
                            : false,
                        },
                      ]
                    : p,
                );
                form.change("part", null);
              }}
            />
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <ScrollTable
            height="25rem"
            headers={[
              {
                key: "manufacturerIndex",
                name: t("global:servicepart.manufacturerindex"),
                width: "3em",
              },
              { key: "name", name: t("global:servicepart.name"), width: "4em" },
              {
                key: "substitute",
                name: t("global:servicepart.substitute"),
                width: "3em",
              },
              {
                key: "price",
                name: t("global:servicepart.price"),
                width: "3em",
              },
              {
                key: "quantity",
                name: t("global:servicepart.quantity"),
                width: "2em",
              },
              { key: "used", name: t("global:servicepart.used"), width: "2em" },
              {
                key: "priceSummary",
                name: t("global:servicepart.priceTotal"),
                width: "3em",
              },
              { key: "button", width: "3em" },
            ]}
            data={selectedParts.map((el) => ({
              ...el,
              substitute: t(`global:${el?.substitute?.toLowerCase()}`),
              priceSummary: memoizedSummaryNetto(el),
              used: (
                <Checkbox
                  disabled
                  sx={{
                    "&.Mui-checked": {
                      color: "var(--BMX-primary)",
                    },
                  }}
                  style={{ padding: "0 16px" }}
                  checked={Boolean(el?.used)}
                />
              ),
              button: (
                <>
                  <IconButton
                    onClick={() => {
                      showModal("editServicePartModal", {
                        initialValues: {
                          price: Boolean(el?.price) ? el?.price : 0,
                          quantity: Boolean(el?.quantity) ? el?.quantity : 1,
                          used: Boolean(el?.used?.value) || Boolean(el?.used),
                        },
                        selectedElement: el,
                        setSelectedParts: setSelectedParts,
                      });
                    }}
                  >
                    <Icon className="primary text" fontSize={"small"}>
                      edit
                    </Icon>
                  </IconButton>

                  <IconButton
                    onClick={() => {
                      showModal("ConfirmModal", {
                        onSubmit: () => {
                          detetePart(el);
                          hideModal("ConfirmModal");
                        },
                      });
                    }}
                  >
                    <Icon className="error text" fontSize={"small"}>
                      delete
                    </Icon>
                  </IconButton>
                </>
              ),
            }))}
          />
        </Col>
      </Row>
      <Row className="mt-4">
        <Col>
          <Field
            name="commentParts"
            component={BMXTextField}
            label={t("global:servicepart.commentparts")}
          />
        </Col>
      </Row>
    </div>
  );
};

export default ServicePartFormStepOne;
